var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRange = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#clip0_324_3435)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 12.5h10M15 14.5l2-2-2-2M9 14.5l-2-2 2-2M5 9.5v6M19 9.5v6"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 0.5,
  y: 1,
  stroke: "currentColor",
  rx: 3.5
})));
export default SvgRange;